import dayjs from 'dayjs'
function download(title, content, fileName) {
  let csvRes = ''
  for (const item of title) {
    csvRes += '"' + item + '",'
  }
  csvRes += '\r\n'
  for (const item of content) {
    let temp = ''
    for (const key in item) {
      temp += '"' + item[key] + '",'
    }
    csvRes += temp + '\r\n'
  }
  const dateForm = dayjs()
    .local()
    .format('YYYY-MM-DD')
  if (MyBrowserIsIE()) {
    // IE10以及Edge浏览器
    var BOM = '\uFEFF'
    var csvData = new Blob([BOM + csvRes], { type: 'text/csv' })
    navigator.msSaveBlob(csvData, `${dateForm}_${fileName}.csv`)
  } else {
    const csvContent = 'data:text/csvcharset=utf-8,\uFEFF' + csvRes
    // 非ie 浏览器
    createDownLoadClick(csvContent, `${dateForm}_${fileName}.csv`)
  }
}
// 创建a标签下载
function createDownLoadClick(content, fileName) {
  const link = document.createElement('a')
  link.href = encodeURI(content)
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
function MyBrowserIsIE() {
  let isIE = false
  if (
    navigator.userAgent.indexOf('compatible') > -1 &&
    navigator.userAgent.indexOf('MSIE') > -1
  ) {
    // ie浏览器
    isIE = true
  }
  if (navigator.userAgent.indexOf('Trident') > -1) {
    // edge 浏览器
    isIE = true
  }
  return isIE
}
export default download
